import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { IconButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/IconButton';
import React, { ReactNode } from 'react';

import styles from './ExpansionContainer.module.scss';
import AddFieldIcon from '@lmt/unicorn-shared/app/icons/add-content.svg?react';
import ExpandMoreIcon from '@lmt/unicorn-shared/app/icons/expand-more.svg?react';

export const ExpansionContainer: React.FC<{
  header: string;
  children?: ReactNode;
  onCreateClick?: () => void;
}> = (props) => {
  return (
    <div>
      <Accordion
        onClick={(e: any) => e.stopPropagation()}
        className={styles.container}
        defaultExpanded={true}
      >
        <AccordionSummary
          id={`${props.header}-header`}
          expandIcon={<ExpandMoreIcon className={styles['expand-icon']} />}
          aria-controls={`${props.header}-content`}
          className={styles.summary}
        >
          <div className={styles.headerContainer}>
            <div className={styles.header}>{props.header}</div>
            {props.onCreateClick && (
              <IconButton
                color="blue"
                iconComponent={<AddFieldIcon />}
                onClick={props.onCreateClick}
                className={styles.createIcon}
              />
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails className={styles.dataContainer}>
          <div>{props.children}</div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
